import React, { useRef, useCallback } from 'react';
import each from 'lodash/each';
import find from 'lodash/find';
import './style.scss';
function getNodeToFocus() {
    var nodeToFocus = null;
    each(document.querySelectorAll('.module'), function (module) {
        if (module.querySelector('nav'))
            return;
        var firstFocusableNode = getFirstFocusableNode(module);
        if (firstFocusableNode) {
            nodeToFocus = firstFocusableNode;
            return false;
        }
    });
    return nodeToFocus;
}
function getFirstFocusableNode(node) {
    var focusableNodes = node.querySelectorAll('a, button, iframe, [tabIndex="0"]');
    return find(focusableNodes, function (node) { return !node.classList.contains('hide') && node.tabIndex > -1; }) || null;
}
var NavFocusSkipper = function () {
    var firstMainContentNode = useRef(null);
    var skipToMainContent = useCallback(function () {
        var _a;
        if (!firstMainContentNode.current) {
            firstMainContentNode.current = getNodeToFocus();
        }
        try {
            (_a = firstMainContentNode.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
        catch (e) {
            console.error('No actionable elements in main content');
        }
    }, []);
    return (React.createElement("a", { href: "#main", onClick: skipToMainContent, style: {
            position: 'fixed',
            opacity: 0,
            top: '-40px',
            left: '10px',
            zIndex: 999,
            borderRadius: '5px',
            padding: '10px',
            background: '#3c763d',
            color: 'white',
            textDecoration: 'underline',
            transition: 'top 0.3s, opacity 0.3s',
        }, onFocus: function (e) {
            e.currentTarget.style.top = '10px';
            e.currentTarget.style.opacity = '1';
        }, onBlur: function (e) {
            e.currentTarget.style.top = '-40px';
            e.currentTarget.style.opacity = '0';
        } }, "Skip to main content"));
};
export default NavFocusSkipper;
